import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/relojchecador/configuracion-tope-justificaciones/';

/**
 * GET Configuración Tope Justificaciones (una por entidad)
 * @returns {Promise<object|null>} La configuración vigente o null si aún no existe.
 */
export const getConfiguracionTopeJustificaciones = async () => {
  try {
    const response = await API.get(baseURI);
    const rows = Array.isArray(response.data) ? response.data : response.data?.results || [];
    return rows[0] || null;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configuración Tope Justificaciones
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionTopeJustificaciones = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuración Tope Justificaciones
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionTopeJustificaciones = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
